import './styles.scss'

import React from 'react'
import { useValues } from 'kea'

import sceneLogic from '~/scenes/search/logic'

export default function TeacherCount () {
  const {
    results: { count },
    startMessage: { teacherCount }
  } = useValues(sceneLogic)

  return (
    <div className='col-1-1 search-breadcrumbs-row'>
      {teacherCount ? <h2 className={`teacher-count only ${!count && 'no-results-found'}`}>{teacherCount}</h2> : null}
    </div>
  )
}
